/** The sizing arithmetic behind `Image`, where it touches the CDN cache key. docs/notes/portals/image-sizing.md */

/**
 * Requested dimensions snap to this grid because the derivative URL is CloudFront's cache key: one page
 * asked for `w:381` and `w:380` of one logo. The rendered attributes stay exact (CLS).
 */
export const DIMENSION_STEP = 8;

export function snapDimension(value: number | undefined): number | undefined {
	if (value === undefined || value <= 0) return value;
	return Math.max(DIMENSION_STEP, Math.round(value / DIMENSION_STEP) * DIMENSION_STEP);
}

/** 1x, 1.5x and 2x of the SNAPPED base, plus 160/320 floors: 4-5 entries instead of 10-11. */
export function getBreakpoints(width: number): number[] {
	const base = snapDimension(width) ?? width;
	const candidates = [160, 320, base, snapDimension(Math.round(base * 1.5)) ?? base, base * 2].filter(
		(w) => w <= base * 2,
	);
	return [...new Set(candidates)].sort((a, b) => a - b);
}

/** Never derived from `getBreakpoints`, which blurred large photos. docs/notes/portals/image-sizing.md */
export function getSizes(width: number): string {
	const base = snapDimension(width) ?? width;
	return `(max-width: ${base}px) 100vw, ${base}px`;
}
